<script setup lang="ts">
const props = defineProps<{
  open?: boolean
}>()

const emit = defineEmits(['hide'])
</script>

<template>
  <div
    class=" row-start-1 row-end-1 col-start-1 col-end-1 px-2xl xl:py-15 flex flex-col gap-12 transform-gpu duration-400 ease-in-out z-80 overflow-y-auto"
    :class="props.open ? 'translate-y-0 bg-background-1 max-h-[calc(100svh-72px)] xl:max-h-none pointer-events-auto' : '-translate-y-full pointer-events-none'"
  >
    <NuxtLink
      to="/wynajem-mieszkan/"
      class="py-2.5 px-3 border-b border-Tertiary w-fit"
      @click="emit('hide')"
    >
      <span class="text-H4 font-semibold! text-Tekst">Wynajem mieszkań</span>
    </NuxtLink>
    <div
      class="flex flex-col xl:flex-row xl:gap-20 justify-between"
      @click="emit('hide')"
    >
      <div class="flex flex-col flex-1">
        <NuxtLink
          class="px-2.5 py-8 border-b border-Tertiary flex flex-row justify-between gap-8 items-center"
          to="/wynajem-mieszkan/#mieszkania-na-wynajem"
        >
          <span class="text-Menu text-Tekst">Mieszkania na wynajem</span>
          <i class="pi pi-arrow-right text-xl" />
        </NuxtLink>
        <NuxtLink
          class="px-2.5 py-8 border-b border-Tertiary flex flex-row justify-between gap-8 items-center"
          to="/wynajem-mieszkan/#dodatkowe-uslugi"
        >
          <span class="text-Menu text-Tekst">Dodatkowe usługi</span>
          <i class="pi pi-arrow-right text-xl" />
        </NuxtLink>
        <NuxtLink
          class="px-2.5 py-8 border-b border-Tertiary flex flex-row justify-between gap-8 items-center"
          to="/wynajem-mieszkan/#plan-inwestycji"
        >
          <span class="text-Menu text-Tekst">Plan inwestycji</span>
          <i class="pi pi-arrow-right text-xl" />
        </NuxtLink>
        <NuxtLink
          class="px-2.5 py-8 border-b border-Tertiary flex flex-row justify-between gap-8 items-center"
          to="/wynajem-mieszkan/#wyszukaj-mieszkanie"
        >
          <span class="text-Menu text-Tekst">Wyszukaj mieszkanie</span>
          <i class="pi pi-arrow-right text-xl" />
        </NuxtLink>
      </div>
      <div class="flex flex-col flex-1">
        <NuxtLink
          class="px-2.5 py-8 border-b border-Tertiary flex flex-row justify-between gap-8 items-center"
          to="/wynajem-mieszkan/#czesci-wspolne"
        >
          <span class="text-Menu text-Tekst">Części wspólne</span>
          <i class="pi pi-arrow-right text-xl" />
        </NuxtLink>
        <NuxtLink
          class="px-2.5 py-8 border-b border-Tertiary flex flex-row justify-between gap-8 items-center"
          to="/wynajem-mieszkan/#jedzenie"
        >
          <span class="text-Menu text-Tekst">Jedzenie</span>
          <i class="pi pi-arrow-right text-xl" />
        </NuxtLink>
        <NuxtLink
          class="px-2.5 py-8 border-b border-Tertiary flex flex-row justify-between gap-8 items-center"
          to="/wynajem-mieszkan/#aktywnosci-i-zycie-spoleczne"
        >
          <span class="text-Menu text-Tekst">Aktywności i życie społeczne</span>
          <i class="pi pi-arrow-right text-xl" />
        </NuxtLink>
      </div>
      <div class="flex flex-col flex-1">
        <NuxtLink
          class="px-2.5 py-8 border-b border-Tertiary flex flex-row justify-between gap-8 items-center"
          to="/wynajem-mieszkan/#kontakt"
        >
          <span class="text-Menu text-Tekst">Kontakt</span>
          <i class="pi pi-arrow-right text-xl" />
        </NuxtLink>
      </div>
    </div>
  </div>
</template>
